// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoadingComponent_loaderContainer__E89ss"};